import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi, AssetLoanApi, HouseKeeperApi, FileApi } from "../../api/api"
import { AssetMgtPageLoaderBase } from "./index"
import { AssetBasicDataProvider } from "../asset_page_base"
import { AssetLoanPage } from "../asset_loan"
import { HouseKeeperHelper } from "../house_keeper_helper"
/**
 * 頁面 /community/assetLoan.aspx 執行此 Page loader
 */
export class AssetMgtLoanLoader extends AssetMgtPageLoaderBase {

    private page: AssetLoanPage

    private initCategories: Promise<void>
    private initAreas: Promise<void>
    private initFacilities: Promise<void>

    constructor() {
        super()
        const assetApi = new AssetApi()
        const assetLoanApi = new AssetLoanApi()
        const assetCategoryApi = new AssetCategoryApi()
        const facilityApi = new FacilityApi()
        const assetAreaApi = new AssetAreaApi()
        const fileApi = new FileApi()
        const assetBasicDataProvider = new AssetBasicDataProvider(assetCategoryApi, facilityApi, assetAreaApi)
        const houseKeeperHelper = new HouseKeeperHelper(new HouseKeeperApi())
        this.page = new AssetLoanPage(assetApi, assetLoanApi, assetBasicDataProvider, fileApi, houseKeeperHelper)
    }

    async load(): Promise<void> {
        this.initCategories = this.page.initCategories()
        this.initAreas = this.page.initAreas()
        this.initFacilities = this.page.initFacilities()
    }

    async loadOnDocumentReady(): Promise<void> {
        this.page.initNoteModal()
        this.page.listenAddCartClick()
        this.page.listenRemoveCartClick()
        this.page.listenProcessLoanClick()
        this.page.initUiElements()
        this.page.listenSortChange()
        this.page.initPagination()
        this.page.initWebCam()
        this.page.updateUserAuthMethod()
        this.page.updateBackPageLink()
        this.page.listenUserAuthClick()
        this.page.listenSignatureClick()
        //https://getbootstrap.com/docs/3.3/javascript/#tabs
        await Promise.all([this.initAreas, this.initCategories, this.initFacilities])
        this.page.initSearchBlock()
    }

}
